import { render, staticRenderFns } from "./ChallengeNotification.vue?vue&type=template&id=02b21032&scoped=true&"
import script from "./ChallengeNotification.vue?vue&type=script&lang=ts&"
export * from "./ChallengeNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeNotification.vue?vue&type=style&index=0&id=02b21032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b21032",
  null
  
)

export default component.exports